var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "firm-configurable-documents-form loading-content-container",
    },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass: "loading-overlay d-flex justify-content-center pt-5",
            },
            [_c("csp-loading-indicator")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoading,
              expression: "!isLoading",
            },
          ],
        },
        [
          _c("b-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.documentTypes.length,
                expression: "documentTypes.length",
              },
            ],
            attrs: {
              fields: _vm.tableFields,
              items: _vm.tableItems,
              responsive: "",
            },
            scopedSlots: _vm._u([
              {
                key: "cell(documentTypeName)",
                fn: function (rowData) {
                  return [
                    _c(
                      "span",
                      { class: rowData.item.belongsToId ? "ml-4" : "" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(rowData.value) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    rowData.item.inheritedFrom
                      ? _c("csp-form-tooltip", {
                          attrs: { tooltip: _vm.buildInheritanceHint(rowData) },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    rowData.item.hasDeprecatedPrintConfig
                      ? _c("csp-form-tooltip", {
                          attrs: {
                            "icon-class": "inticon-print deprecation-warning",
                            tooltip:
                              "Es existiert eine alte Dokumentkonfiguration für Druck",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    rowData.item.hasDeprecatedSignConfig
                      ? _c("csp-form-tooltip", {
                          attrs: {
                            "icon-class":
                              "inticon-signature deprecation-warning",
                            tooltip:
                              "Es existiert eine alte Dokumentkonfiguration für Unterschrift",
                          },
                        })
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "cell(documentName)",
                fn: function (rowData) {
                  return [
                    _c(
                      "span",
                      {
                        class: rowData.item.inheritedFrom
                          ? "inherited-document"
                          : "",
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.buildDocumentName(rowData)) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(excludeDocument)",
                fn: function (rowData) {
                  return [
                    rowData.item.isUsableDocumentType && rowData.item.documentId
                      ? _c(
                          "b-form-checkbox",
                          {
                            attrs: {
                              disabled: _vm.isExcludeDocumentReadonly(rowData),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.updateExcludeDocument(
                                  $event,
                                  rowData
                                )
                              },
                            },
                            model: {
                              value: rowData.item.excludeDocument,
                              callback: function ($$v) {
                                _vm.$set(rowData.item, "excludeDocument", $$v)
                              },
                              expression: "rowData.item.excludeDocument",
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                class: rowData.item.inheritedFrom
                                  ? "inherited-document"
                                  : "",
                              },
                              [
                                _vm._v(
                                  "\n                        Dokument ausblenden\n                    "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (rowData) {
                  return [
                    _c(
                      "div",
                      { staticClass: "table-actions" },
                      [
                        _vm.canShowFile(rowData)
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.buildFilePreviewUrl(rowData),
                                  target: "_blank",
                                  title: "Anzeigen",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "inticon-autoclaim_detail",
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canShowFile(rowData)
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.buildFileDownloadUrl(rowData),
                                  title: "Datei herunterladen",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "inticon-autoclaim_einzeldownload",
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canDeleteFile(rowData)
                          ? _c(
                              "a",
                              {
                                attrs: { href: "#", title: "Dokument Löschen" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.deleteFile(rowData)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "inticon-autoclaim_loschen",
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canUploadFile(rowData)
                          ? _c("csp-firm-document-upload", {
                              attrs: {
                                "context-id": _vm.contextId,
                                "context-type": _vm.contextType,
                                "document-type-id": rowData.item.documentTypeId,
                              },
                              on: {
                                "upload-error": function ($event) {
                                  _vm.isLoading = false
                                },
                                "upload-start": function ($event) {
                                  _vm.isLoading = true
                                },
                                "upload-success": function ($event) {
                                  return _vm.handleFileUploadSuccess()
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.documentTypes.length === 0 && !_vm.isLoading,
                  expression: "documentTypes.length === 0 && !isLoading",
                },
              ],
              staticClass: "collapse-body",
            },
            [
              _c(
                "b-alert",
                { staticClass: "mb-0", attrs: { show: true, variant: "info" } },
                [
                  _vm._v(
                    "\n                Noch keine Dateien vorhanden.\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }